import { render } from "./RuleConfig.vue?vue&type=template&id=689d9f0b&scoped=true"
import script from "./RuleConfig.vue?vue&type=script&lang=js"
export * from "./RuleConfig.vue?vue&type=script&lang=js"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-689d9f0b"]])

export default __exports__